import React, { FunctionComponent } from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import { NotificationDelay } from '../../common/types'
import { Icon } from '../icons/Icon'
import { Container, Content, IconWrapper, Message, Title } from './styles'
import { dismissToast } from '.'
import { Button } from '../Button'

export const setErrorNotification = (title: string, message: string, noDelay?: boolean) => {
  if (!toast.isActive(title)) {
    toast.error(<ErrorNotification title={title} message={message} />, {
      autoClose: false,
      closeButton: false,
      delay: 0,
      toastId: title,
    })
    if (noDelay) {
      dismissToast(title, 0)
    } else {
      dismissToast(title, NotificationDelay.errorNotificationDelay)
    }
  }
}

interface ErrorNotificationProps {
  title: string
  message: string
  toastId?: string
  children?: React.ReactNode
}

export const ErrorNotification: FunctionComponent<ErrorNotificationProps> = ({
  title,
  message,
  toastId = title,
  children,
}) => {
  const dismiss = () => toast.dismiss(toastId)
  return (
    <ErrorContainer>
      <IconWrapper>
        <Icon size="big" icon={'error'} color="red900" />
      </IconWrapper>
      <Content>
        <Title>{title}</Title>
        <Message>{message}</Message>
      </Content>
      {children}
      <CloseButtonContainer
        style={{ display: 'flex', width: 'auto', alignItems: 'center', justifyContent: 'end', textAlign: 'center' }}
      >
        <Button maxWidth="40px" iconSize="sm" category="cancel" onClick={dismiss}>
          <Icon size="small" icon={'close'} color="white" />
        </Button>
      </CloseButtonContainer>
    </ErrorContainer>
  )
}

const CloseButtonContainer = styled.div`
  display: flex,
  width: auto;
  align-items: "center";
  justify-content: "end";
  text-align: "center"
`
const ErrorContainer = styled(Container as any)`
  background-color: ${props => props.theme.colors.red100};
  color: ${props => props.theme.colors.red900};
  border-bottom: 1px solid ${props => props.theme.colors.red500};
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    padding: 1em;
  }
`
